import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown } from 'lucide-react';

const StatCard = ({ 
  title, 
  value, 
  icon: Icon, 
  trend, 
  bgColor = 'bg-gradient-to-br from-slate-50 to-slate-100',
  prefix = '',
  suffix = ''
}) => {
  const isPositive = trend >= 0;

  return (
    <motion.div
      whileHover={{ y: -4, boxShadow: '0 20px 40px rgba(0,0,0,0.08)' }}
      className={`${bgColor} rounded-xl p-6 border border-gray-100 shadow-sm transition-all duration-300`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-gray-600 text-sm font-medium mb-2">{title}</p>
          <div className="flex items-baseline gap-2">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900">
              {prefix}{value}{suffix}
            </h3>
            {trend !== undefined && (
              <div className={`flex items-center gap-1 text-xs font-semibold ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
                {isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
                {Math.abs(trend)}%
              </div>
            )}
          </div>
        </div>
        <div className="bg-white/60 rounded-lg p-3 backdrop-blur-sm">
          <Icon size={24} className="text-gray-700" />
        </div>
      </div>
    </motion.div>
  );
};

export default StatCard;
